import * as d3 from 'd3';
export function createTooltip() {
    return d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip bg-white text-black px-2 py-1 border rounded shadow-lg')
        .style('position', 'absolute')
        .style('visibility', 'hidden');
}
